/*
  "Prateleira rosa" — interacoes do carrossel:
  1) Setas: rolam a track (delegacao no document p/ multiplas instancias).
  2) Drag-scroll (desktop/mouse): arrasta a fileira 1:1 com captura de ponteiro.
     Limiar de 8px separa clique de arraste; quando houve arraste, o clique
     seguinte e suprimido pra nao abrir o card. Snap solto durante o arraste.
  3) Cursor "Arraste" (estilo Rhode): circulo rosa que segue o mouse no desktop
     e some sobre os controles clicaveis (comprar / favoritar / pilulas).
  Touch usa o scroll nativo do dedo (sem drag JS e sem cursor).
*/
(function () {
  if (window.__prsRailBound) return;
  window.__prsRailBound = true;

  var RAIL = '.prs-track--swipe';
  // controles onde o drag nao inicia e o cursor "Arraste" some
  var CONTROLS = '.prs-card__btn, .prs-card__fav, .prs-card__pills, .prs-card__form';
  var fine = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  /* ------------------------------------------------------------------ setas */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.prs-arrow');
    if (!btn) return;
    var section = btn.closest('.prs-section');
    var track = section && section.querySelector('.prs-track');
    if (!track) return;
    var dir = btn.classList.contains('prs-arrow--next') ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
  });

  /* ------------------------------------------------- cursor "Arraste" (cue) */
  var cue = null;
  function ensureCue() {
    if (cue || !fine) return cue;
    cue = document.createElement('div');
    cue.className = 'prs-cue';
    cue.textContent = 'Arraste';
    cue.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cue);
    return cue;
  }

  if (fine) {
    document.addEventListener('mousemove', function (e) {
      var rail = e.target.closest(RAIL);
      var overControl = e.target.closest(CONTROLS);
      if (rail && !overControl) {
        ensureCue();
        cue.style.transform =
          'translate(' + e.clientX + 'px,' + e.clientY + 'px) translate(-50%,-50%)';
        cue.classList.add('is-on');
      } else if (cue) {
        cue.classList.remove('is-on');
      }
    });
    document.addEventListener('mouseleave', function () {
      if (cue) cue.classList.remove('is-on');
    });
    // some na hora ao rolar a pagina (o mousemove nao dispara durante o scroll)
    window.addEventListener('scroll', function () {
      if (cue) cue.classList.remove('is-on');
    }, { passive: true });
  }

  /* --------------------------------------------------------- drag-scroll */
  // Sem isso o navegador inicia o drag nativo ao puxar a imagem ou o link do
  // card: dispara pointercancel, o arraste aborta e a fileira nao rola.
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest(RAIL)) e.preventDefault();
  });

  /* Inercia: ao soltar, a fileira continua deslizando e vai desacelerando, em
     vez de parar seco. O snap fica desligado ate a inercia terminar, senao o
     card seria puxado de volta no meio do movimento. */
  var glideRaf = 0;
  var glideRail = null;

  function endGlide() {
    if (glideRaf) cancelAnimationFrame(glideRaf);
    glideRaf = 0;
    if (glideRail) {
      glideRail.style.scrollSnapType = '';
      glideRail.classList.remove('is-dragging');
      glideRail = null;
    }
  }

  function glide(rail, speed) {
    glideRail = rail;
    var last = performance.now();
    var max = rail.scrollWidth - rail.clientWidth;
    function step(now) {
      var dt = Math.min(now - last, 50); // ignora saltos de aba em segundo plano
      last = now;
      speed *= Math.pow(0.94, dt / 16.67); // atrito igual em qualquer refresh rate
      var next = rail.scrollLeft + speed * dt;
      if (Math.abs(speed) < 0.02 || next <= 0 || next >= max) {
        rail.scrollLeft = Math.min(Math.max(next, 0), max);
        endGlide();
        return;
      }
      rail.scrollLeft = next;
      glideRaf = requestAnimationFrame(step);
    }
    glideRaf = requestAnimationFrame(step);
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return; // so botao esquerdo do mouse
    var rail = e.target.closest(RAIL);
    if (!rail) return;
    if (e.target.closest(CONTROLS)) return; // deixa o controle clicavel funcionar

    endGlide(); // pegar a fileira no meio do deslize interrompe a inercia

    var startX = e.clientX;
    var startSL = rail.scrollLeft;
    var pointerId = e.pointerId;
    var dragged = false; // so vira true quando passa do limiar de 8px
    var lastX = e.clientX;
    var lastT = performance.now();
    var speed = 0; // px por ms, no sentido do scroll

    function onMove(ev) {
      if (ev.pointerId !== pointerId) return;
      var dx = startX - ev.clientX;
      if (!dragged) {
        // ainda nao e arraste: NAO captura o ponteiro, pra nao quebrar o clique
        if (Math.abs(dx) <= 8) return;
        dragged = true;
        // arraste confirmado -> agora sim captura e solta o snap
        try { rail.setPointerCapture(pointerId); } catch (err) {}
        rail.style.scrollSnapType = 'none';
        rail.classList.add('is-dragging');
      }
      var now = performance.now();
      var dt = now - lastT;
      if (dt > 0) {
        // media com a leitura anterior pra amaciar picos de amostragem
        speed = 0.7 * ((lastX - ev.clientX) / dt) + 0.3 * speed;
        lastX = ev.clientX;
        lastT = now;
      }
      rail.scrollLeft = startSL + dx; // rola 1:1 com o ponteiro
      ev.preventDefault();            // evita selecao de texto/imagem durante o arraste
    }
    function onUp() {
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      document.removeEventListener('pointercancel', onUp);

      if (!dragged) return; // foi um clique simples: deixa o clique seguir normal

      try { rail.releasePointerCapture(pointerId); } catch (err) {}

      // parou o ponteiro antes de soltar? entao e pra ficar onde esta
      if (performance.now() - lastT > 80) speed = 0;

      if (Math.abs(speed) > 0.05) {
        glide(rail, speed); // is-dragging e snap saem no fim da inercia
      } else {
        rail.style.scrollSnapType = '';
        rail.classList.remove('is-dragging');
      }

      // bloqueia so o proximo clique pra nao abrir o card ao soltar o arraste
      var block = function (clickEv) {
        clickEv.stopPropagation();
        clickEv.preventDefault();
      };
      document.addEventListener('click', block, { capture: true, once: true });
      setTimeout(function () {
        document.removeEventListener('click', block, { capture: true });
      }, 60);
    }
    document.addEventListener('pointermove', onMove);
    document.addEventListener('pointerup', onUp);
    document.addEventListener('pointercancel', onUp);
  });
})();
